var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgErrorMessageIcon = function SvgErrorMessageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "activity-down-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.83,
    height: 23.859
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.847.001a1.556 1.556 0 0 0-1.274.756L.206 21.602a1.472 1.472 0 0 0 0 1.507 1.556 1.556 0 0 0 1.342.75h24.729a1.56 1.56 0 0 0 1.344-.75 1.472 1.472 0 0 0 0-1.507L15.247.757a1.562 1.562 0 0 0-1.408-.756Zm.072 6.3a1 1 0 0 1 .995.995v9.278a.995.995 0 0 1-1.989 0V7.291a1 1 0 0 1 .99-.995Zm0 11.929a.995.995 0 1 1-.995.995 1 1 0 0 1 .995-.995Z"
  })));
};
export default SvgErrorMessageIcon;